import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAppPlatformUserAccessManagement } from '@ecap3/app-platform-user-access-management';
import {
    PlatformDataService,
    ShellDomainProvider,
    SqlQueryBuilderService,
    StorageDataService
} from '@ecap3/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DELTA_CONFIG } from 'src/app/delta-config/constant/delta-config.constant';
import { UpdateUserBuisnessCommand } from 'src/app/shared/models/personal-info-edit.model';

@Injectable({
    providedIn: 'root'
})
export class AppUserManagementService
    implements IAppPlatformUserAccessManagement
{
    header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });
    profileImageChangedOb : BehaviorSubject<any> = new BehaviorSubject<any>(null);
    constructor(
        private http: HttpClient,
        private sqlQueryBuilderService: SqlQueryBuilderService,
        private platformDataService: PlatformDataService,
        private storageService: StorageDataService
    ) {}

    getUpdatedUserInfo(userList): Observable<any> {
        const callList = [];
        callList.push(this.getPersonByUserIds(userList));
        return combineLatest(callList as Observable<any>[]).pipe(
            map((res: any[]) => {
                const persons = res[0];
                userList.forEach((user) => {
                    persons.forEach((person) => {
                        if (person['CreatedBy'] !== user['ItemId']) {
                            return;
                        }
                        user['PersonId'] = person['ItemId'];
                        user['ProfileImage'] = person['ProfileImageId'];
                    });
                });
                this.topFunction();
                return userList;
            })
        );
    }

    getProfileImageChangeObservable() {
        return this.profileImageChangedOb as Observable<any>;
    }

    getPersonByUserIds(userList: any[]): Observable<any> {
        const filters = [];
        filters.push({
            property: 'Tags',
            operator: 'contains',
            value: DELTA_CONFIG.Tags.Person
        });
        filters.push({
            property: 'CreatedBy',
            operator: 'contains',
            value: userList.map((user) => user['ItemId'])
        });
        const fields = DELTA_CONFIG.AllFieldsOfEntity.Person;
        const query = this.sqlQueryBuilderService.prepareQuery(
            DELTA_CONFIG.Entity.DeltaEmployee,
            fields,
            filters,
            'CreateDate __asc',
            0,
            1000
        );
        return this.platformDataService
            .getBySqlFilter(DELTA_CONFIG.Entity.DeltaEmployee, query)
            .pipe(
                map((response: Response) => {
                    const results = response.body['Results'];
                    const personData = results;
                    return personData;
                })
            );
    }

    topFunction() {
        document.getElementById('container-3').scrollTop = 0;
    }

    updateUser(userInfo: UpdateUserBuisnessCommand): Observable<any> {
        // const validUserInfo = new UpdateUserBuisnessCommand(userInfo);

        return this.http
            .post(
                ShellDomainProvider['api'].Security +
                    'SecurityCommand/UpdateUser',
                userInfo,
                {
                    headers: this.header,
                    withCredentials: true,
                    observe: 'response'
                }
            )
            .pipe(map((response: any) => response));
    }

    updateProfileImage({Email, ProfileImageId, ProfileImageUrl}: {Email: string, ProfileImageId: string, ProfileImageUrl: string}): Observable<any> {
        const payload = {
            Email,
            ProfileImageId,
            ProfileImageUrl
        }
        return this.http
            .post(ShellDomainProvider['api'].BusinessService + '/DeltaService/Employee/UpdateProfileImage', payload, {
                headers: this.header,
                withCredentials: true,
                observe: 'response',
            })
            .pipe(map((response: any) => response.body));
    }

    upsertEmployeeProfileInfo(payload: any): Observable<any> {
        return this.http
            .post(ShellDomainProvider['api'].BusinessService + '/DeltaService/Employee/UpsertEmployeeProfileInfo', payload, {
                headers: this.header,
                withCredentials: true,
                observe: 'response',
            })
            .pipe(map((response: any) => response.body));
    }

    getEmployeeProfileInfo(employeeId: string): Observable<any> {
        return this.http
            .get(ShellDomainProvider['api'].BusinessService + `/DeltaService/Employee/GetEmployeeProfileInfo?employeeId=${employeeId}`, {
                headers: this.header,
                withCredentials: true,
                observe: 'response',
            })
            .pipe(map((response: any) => response.body));
    }

    getFileUrl(fileId: string) {
        return this.storageService.getFilesInfo([fileId]).pipe(map((response: any) => {
            if (response && response.body && response.body.length) {
                return response.body[0];
            } else {
                return {};
            }
        }));
    }
}
